import  React, { useState, useRef, useEffect  } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Icons } from "../assest/icons";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { logger } from '../utils/logger';
import Moment from 'moment';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { useGoogleLogin } from "@react-oauth/google";
import Modal from 'react-modal';
import { ToastContainer, toast } from "react-toastify";
import LeftSideLogin from "./leftsidelogin";
import ConsentNotice from "./consenttext";
import { getUserByEmail, updateUser, getUser, createInsuranceData, getInsuranceData } from '../services/firestore';
import { validatePassword } from '../utils/passwordValidation';
import { fetchWithAppCheck } from '../utils/fetchWithAppCheck';
import { saveFHIRPatient, saveFHIRCoverage } from '../services/fhirService';
import { signInWithCustomToken } from 'firebase/auth';
import { auth } from '../firebase.config';



function SingupScreen() {  
  let navigate = useNavigate();  
  const [showCalendar, setShowCalendar] = useState(false);
  

  const [UserData, setUserData] = useState([]);

  const [ShowLoader, setShowLoader] = useState(false);

  const [GShowLoader, setGShowLoader] = useState(false);
  const [UserId, setUserId] = useState('');
  const [firstStep, setFirstStep] = useState(true);
  const [twoStep, setTwoStep] = useState(false);
  const [threeStep, setThreeStep] = useState(false);
  const [finalStep, setFinalStep] = useState(false);

  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [password, setPassword] = useState('');
  const [selectedToggle, setSelectedToggle] = useState(true);
  const [DOBTxt, setDOBTxt] = useState('');
  const [GenderTxt, setGenderTxt] = useState('');
  const [InsuranceIdTxt, setInsuranceIdTxt] = useState('');
  const [ClearBtn, setClearBtn] = useState(false);

  const [AgeTxt, setAgeTxt] = useState('');
  const [WeightTxt, setWeightTxt] = useState('');
  const [HeightTxt, setHeightTxt] = useState('');

  const [errors, setErrors] = useState({});
  const [isValid, setIsValid] = useState(false); 
  
  const [focused, setFocused] = React.useState(false);
  const [passwordType, setPasswordType] = useState("password");
  
  const [isCheckedAgree, setIsCheckedAgree] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [isGmail, setIsGmail] = useState(false);

  const [timer, setTimer] = useState(120); // Initial timer value
  const [resendAvailable, setResendAvailable] = useState(false); // Resend button state
  const intervalRef = useRef(null); // Store interval reference to clear it later
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal open/close state


// Open modal and set selected document
const openModal = (doc) => {  
  setIsModalOpen(true);
};

// Close modal and reset selected document
const closeModal = () => {
  setIsModalOpen(false); 
};

  const handleChange = () => {
    setIsChecked(!isChecked);
    setSelectedToggle(!selectedToggle); 
  };


  const handleClickPassword = (event) => { 
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };
  const handlePasswordChange = (event) => {
    const { value } = event.target;
    setPassword(value);
    setErrors('');
};
const handleEmailChange = (event) => {
   // Regular expression for email validation
   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const { value } = event.target;
  setEmail(value);
    // Validate email
    if (!emailRegex.test(value)) {
      setErrors('Invalid email address');
    } else {
      setErrors('');
    } 

};
  function handleOnFocus() {
    setFocused(true);
  }

  function handleOnBlur() {
    setFocused(false);
  }
  const [errorMessage, setErrorMessage] = useState('');

  const nav = useNavigate();
  const routeChange = () =>{
    localStorage.setItem('UserLoginStatus',  JSON.stringify(true) );
    sessionStorage.setItem('aigi_session_alive', 'true');
    nav("/dashboard", { state:UserData});
  }
  const routeFillUserInfo = () =>{
    localStorage.setItem('UserLoginStatus',  JSON.stringify(true) );
    sessionStorage.setItem('aigi_session_alive', 'true');
    nav("/filluserinfo", { state:UserData});
  }

  const handleResetFormStart= () => {
    setFullName('');
    setEmail('');
    setPhoneNumber('');
    setPassword(''); 
    setErrors('');
  };
  const handleResetForm1 = () => { 
    setPassword(''); 
    setErrors('');
  };
  const handleResetForm2 = () => { 
    setDOBTxt('');
    setGenderTxt('');
    setInsuranceIdTxt('');
    setErrors('');
  }; 
  const handleOptionChangeToogle = () => {
    setSelectedToggle(!selectedToggle); 
  };
  const handleClickFirst = () => {
    setFirstStep(false);
    setTwoStep(false);
    setThreeStep(true);
    setFinalStep(false);
  };  
  const handleClickTwo = () => {
    setFirstStep(false);
    setTwoStep(true);
    setThreeStep(false);
    setFinalStep(false); 
    startTimer();
    setResendAvailable(false); // Disable resend button immediately
  };  
 
  const handleClickThree = () => {
    setFirstStep(false);
    setTwoStep(false);
    setFinalStep(true);
    setThreeStep(false);
  };
  const handleClickFinal = () => {
    setFirstStep(false);
    setTwoStep(false);
    setFinalStep(true);
    setThreeStep(false);
  };

 // Timer function to start the countdown
 const startTimer = () => {
  setTimer(120); // Reset the timer to 30 seconds
  setResendAvailable(false); // Disable the resend button
  clearInterval(intervalRef.current); // Clear any existing interval

  intervalRef.current = setInterval(() => {
    setTimer((prev) => {
      if (prev <= 1) {
        clearInterval(intervalRef.current); // Stop the timer at 0
        setResendAvailable(true); // Enable resend button
        return 0; // Ensure timer does not go below 0
      }
      return prev - 1; // Decrement the timer
    });
  }, 1000);
};

  // Clear the timer on component unmount to prevent memory leaks
  useEffect(() => {
    return () => clearInterval(intervalRef.current);
  }, []);

const handleFullNameChange = (event) => {
  // Remove non-text characters from the input value
  const value = event.target.value.replace(/[^a-zA-Z\s]/g, '');
  //const value = event.target.value ;
  setFullName(value);
  setErrors('');
};



  const handleSubmit = async (event, skipConsentCheck = false) => {
    if (event) event.preventDefault(); // Prevent form reload if event exists

    // Simple form validation
    let formErrors = {};
    if (!fullName.trim()) {
      formErrors.fullName = 'Please enter your full name';
    }
    if (!email.trim()) {
      formErrors.email = 'Please enter your email';
    }
    if (!isValidEmail(email)) {
      formErrors.email = 'Please enter a valid email address';
    }
    if (!phoneNumber.trim()) {
      formErrors.phoneNumber = 'Please enter your phone number';
    } else if (phoneNumber.replace(/\D/g, '').length < 10) {
      formErrors.phoneNumber = 'Please enter a valid phone number (at least 10 digits)';
    }

    // Validate password only if isGmail is false
    if (!isGmail) {
      if (!password.trim()) {
        formErrors.password = 'Please enter your password';
      } else {
        const pwdCheck = validatePassword(password);
        if (!pwdCheck.valid) {
          formErrors.password = pwdCheck.error;
        }
      }
    }
 
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }
    
    if (!isCheckedAgree && !skipConsentCheck) {
      openModal();
      return;
    }
    
    setShowLoader(true);
    
    try {
      const functionsBase = process.env.REACT_APP_FUNCTIONS_BASE_URL
        || 'https://us-central1-aigicare-prod.cloudfunctions.net';

      // Create account server-side — bcrypt and Firestore write via Cloud Function
      const signupRes = await fetchWithAppCheck(`${functionsBase}/createPatientAccount`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          fullName,
          email,
          phoneNumber,
          password: isGmail ? undefined : password,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          login_from: isGmail ? 'google' : 'direct',
        }),
      });
      const signupData = await signupRes.json();

      if (!signupRes.ok) {
        const msg = signupData.message === 'User with this email already exists'
          ? 'User with this email already exists'
          : 'Registration failed. Please try again.';
        toast.error(msg, { position: toast.POSITION.TOP_RIGHT });
        setShowLoader(false);
        return;
      }

      const userId = signupData.userId;

      // Sign in with Firebase Auth so protected routes work
      if (signupData.customToken) {
        try {
          await signInWithCustomToken(auth, signupData.customToken);
        } catch (authErr) {
          logger.warn('Firebase Auth sign-in after signup failed:', authErr);
        }
      }

      // Local userData used for emails and FHIR (no password field — never kept in browser)
      const userData = {
        fullName: fullName,
        email: email,
        phoneNumber: phoneNumber,
        login_from: isGmail ? "google" : "direct",
        created_on: new Date().toISOString(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };

      // FHIR: Save Patient resource (fire-and-forget)
      saveFHIRPatient({ ...userData, fullName, email, phoneNumber }, userId);

      toast.success("User registered successfully!", {
        position: toast.POSITION.TOP_RIGHT,
      });

      // Welcome email + MA notification are now handled server-side by
      // the createPatientAccount Cloud Function (Admin SDK access).

      // Prepare result object similar to API response
      const result = {
        ...userData,
        user_id: userId,
        id: userId,
        status: 'success'
      };
      
      // Save user profile in localStorage and state
      localStorage.setItem('UserProfile', JSON.stringify(result));
      localStorage.setItem('UserId', JSON.stringify(userId));
      localStorage.setItem('UserLoginStatus', JSON.stringify(true));
      sessionStorage.setItem('aigi_session_alive', 'true');
      
      setUserData(result);
      setUserId(userId);
      
      logger.info('User ID saved after registration:', userId);
      
      setShowLoader(false);
      handleResetForm1();
      routeFillUserInfo();
      
    } catch (error) {
      logger.error('Error during registration:', error);
      toast.error(error.message || 'An unexpected error occurred. Please try again later.', {
        position: toast.POSITION.TOP_RIGHT,
      });
      setShowLoader(false);
    }
  };

    const isValidEmail = (email) => {
      // Regular expression to validate email format
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
    };
    const isValidDateFormat = (dateString) => {
      const regex = /^\d{4}-\d{2}-\d{2}$/;
      return regex.test(dateString);
  };
  const onChangeCalendar = (date) => {
     const dateNew = new Date(date);     
    setDOBTxt(new Date(date));
    setShowCalendar(false);
    setErrors('');
};
  const toggleCalendar = () => {
    setShowCalendar(!showCalendar);
};
    const handleClearDate = () => {
      setClearBtn(false);
      // Clear the date by setting the dob state to an empty string
      setDOBTxt('');
  };
  const handleGenderChange = (e) => {
    setGenderTxt(e.target.value);
  };
  
const handleSubmitPart2 = async (event) => {
  event.preventDefault();
  
  // Simple form validation
  let formErrors = {};
  if (!DOBTxt.length > 0) {
    formErrors.DOBTxt = 'Please select a date';
  } else {
    const age = Moment().diff(Moment(DOBTxt), 'years');
    if (age < 18) {
      formErrors.DOBTxt = 'You must be at least 18 years old to register';
    }
  }
  if (!GenderTxt.trim()) {
    formErrors.GenderTxt = 'Please enter your gender';
  }
  if (!InsuranceIdTxt.trim()) {
    formErrors.InsuranceIdTxt = 'Please enter your Insurance ID';
  }
  
  if (Object.keys(formErrors).length > 0) {
    setErrors(formErrors);
    return;
  }
  
  setShowLoader(true);
  
  try {
    // Update user in Firestore
    await updateUser(UserId, {
      dob: DOBTxt,
      gender: GenderTxt,
      insurance: InsuranceIdTxt,
    });

    // FHIR: Update Patient resource with DOB and gender (fire-and-forget)
    saveFHIRPatient({ fullName, email, phoneNumber, dob: DOBTxt, gender: GenderTxt }, UserId);

    // Also save insurance to insurance_data collection so admin/patient portals can read it
    if (InsuranceIdTxt.trim()) {
      try {
        const existingInsurance = await getInsuranceData(UserId);
        if (!existingInsurance || existingInsurance.length === 0) {
          await createInsuranceData({
            user_id: UserId,
            policy_id: InsuranceIdTxt,
          });
          // FHIR: Save Coverage resource (fire-and-forget)
          saveFHIRCoverage({ policy_id: InsuranceIdTxt, user_id: UserId }, UserId);
        }
      } catch (e) {
        logger.warn('Could not save insurance data record:', e);
      }
    }

    // Get updated user data
    const updatedUser = await getUser(UserId);
    
    toast.success("User profile updated successfully!", {
      position: toast.POSITION.TOP_RIGHT,
    });
    
    const updatedProfile = {
      ...updatedUser,
      fullName, email, phoneNumber
    };
    
    localStorage.setItem('UserProfile', JSON.stringify(updatedProfile));
    setUserData(updatedProfile);
    setShowLoader(false);
    
  } catch (error) {
    logger.error('Error updating profile:', error);
    toast.error('Failed to update profile', {
      position: toast.POSITION.TOP_RIGHT,
    });
    setShowLoader(false);
  }
};
  const formatDate = (date) => {
     return date ? date.toString().slice(0, 10) : '';
};
const disablePastDates = ({ activeStartDate, date, view }) => {
  // Disable dates before the current date
  // return date >= new Date();
  return date.getMonth() > new Date().getMonth() || date.getFullYear() > new Date().getFullYear() || date >= new Date();
};

const InsuranceIdHandleKeyDown = (e) => {
 
};

const InsuranceIdHandleChange = (e) => {
    // Get the new value
    const value = e.target.value;
    let filteredValue = '';

  // Iterate over each character in the input value
  for (let i = 0; i < value.length; i++) {
    const char = value[i];
    // Allow alphanumeric characters and hyphens
    if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z') || (char >= '0' && char <= '9') || char === '-') {
      filteredValue += char;
    }
  }
    // Update the state with the filtered value
    setInsuranceIdTxt(filteredValue); 
};


const [showAccessToken, setAccessToken] = useState('');  
const [UserLoginStatus, setUserLoginStatus] = useState('');  

const googleLogin = useGoogleLogin({
  onSuccess: async (tokenResponse) => { 
    setAccessToken(tokenResponse.access_token);
    checkGoogleLogin(tokenResponse.access_token)
  },
  onError: (errorResponse) => {
    // Error handled silently
  },
});
const checkGoogleLogin = async (accessToken) => {
  setGShowLoader(true);
  
  try {
    // Get user info from Google
    const response = await fetch(
      `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${accessToken}`
    );
    const googleUser = await response.json();
    
    logger.info('Google user info (signup):', googleUser);
    
    // Quick pre-check: if user already exists, redirect to login.
    // This is a UX optimisation — the createPatientAccount CF also checks
    // email uniqueness, so nothing breaks if this read is denied by rules.
    try {
      const existingUser = await getUserByEmail(googleUser.email);
      if (existingUser) {
        toast.info('Account already exists. Please login.', {
          position: toast.POSITION.TOP_RIGHT,
        });
        setGShowLoader(false);
        nav('/');
        return;
      }
    } catch (_preCheckErr) {
      // Firestore rules may block unauthenticated reads — proceed anyway.
      // Duplicate emails are caught server-side by createPatientAccount CF.
    }
    
    // New user - populate form with Google data
    toast.success('Gmail verification successful. Please complete your registration.', {
      position: toast.POSITION.TOP_RIGHT,
    });
    
    setFullName(googleUser.name);
    setEmail(googleUser.email);
    setIsGmail(true);
    setGShowLoader(false);
    
    // Store temporary Google user data
    const tempUserData = {
      email: googleUser.email,
      fullName: googleUser.name,
      isGmail: true,
      isGoogleSignup: true,
    };
    
    localStorage.setItem('TempGoogleUserData', JSON.stringify(tempUserData));
    
  } catch (error) {
    logger.error('Error during Google signup:', error);
    toast.error(error.message || 'An error occurred. Please try again.', {
      position: toast.POSITION.TOP_RIGHT,
    });
    setGShowLoader(false);
  }
};

  const [otp, setOtp] = useState(new Array(4).fill('')); // OTP state 
  const inputRefs = useRef([]); // Ref for managing input focus

// Handle input change for OTP fields
const handleOTPChange = (element, index) => {
  if (isNaN(element.value)) return; // Allow only numbers

  const newOtp = [...otp];
  newOtp[index] = element.value;
  setOtp(newOtp);

  // Move to the next input field automatically
  if (element.nextSibling) {
    element.nextSibling.focus();
  }
};

 // OTP verification not currently used - registration goes directly to Firestore
 const handleSubmitOTP = async (e) => {
  e.preventDefault();
  setShowLoader(true);
  
  toast.info('OTP verification not required', {
    position: toast.POSITION.TOP_RIGHT,
  });
  
  setShowLoader(false);
  routeFillUserInfo();
};
// Handle backspace functionality
const handleBackspace = (e, index) => {
  if (e.key === 'Backspace' && !otp[index] && index > 0) {
    inputRefs.current[index - 1].focus(); // Move focus to the previous input
  }
};

  // Handle OTP Paste functionality
  const handlePaste = (e) => {
    const pasteData = e.clipboardData.getData('text').slice(0, otp.length); // Extract required digits
    const newOtp = [...otp];

    for (let i = 0; i < pasteData.length; i++) {
      if (!isNaN(pasteData[i])) {
        newOtp[i] = pasteData[i];
      }
    }
    setOtp(newOtp);

    // Focus on the next empty field (or last field if all are filled)
    const lastFilledIndex = Math.min(pasteData.length - 1, otp.length - 1);
    inputRefs.current[lastFilledIndex].focus();
  };


// OTP resend not currently used - registration goes directly to Firestore
const handleResend = async (e) => {
  e.preventDefault();
  setOtp(new Array(4).fill(''));
  
  toast.info('OTP verification not required', {
    position: toast.POSITION.TOP_RIGHT,
  });
  
  startTimer();
  setResendAvailable(false);
};
// Check if all OTP fields are filled
const isOtpComplete = otp.every((digit) => digit !== '');
// // Timer logic for enabling the resend button
// useEffect(() => {
//   if (timer > 0) {
//     const countdown = setInterval(() => {
//       setTimer((prev) => prev - 1);
//     }, 1000);
//     return () => clearInterval(countdown);
//   } else {
//     setResendAvailable(true);
//   }
// }, [timer]);

// Use useEffect to monitor state changes
useEffect(() => {
  // logger.info(isCheckedAgree);
}, [isCheckedAgree]);

const handleAgree = async () => {
  setIsCheckedAgree(true);
  closeModal();
  await handleSubmit(null, true); // skip consent check since user just agreed
};

const handleDecline = () => {
  closeModal(); // Just close the modal on decline
};


  return (
    <div>
      <div className='container-fluid p-0 bgImageUrl'>
       
        <div className='container p-0 contentBody loginScreen'>

        <LeftSideLogin/>
          <div className="col-lg-5 d-inline-block position-relative">
            <div className="loginBoxDiv">
            <div className={"singUpFirstStep "+(firstStep ? "":"d-none")}>
                <h3 className="titleDespTxt">Sign up to AIGI Care</h3>
                <span className={"otherSignInOpt " + (isGmail ? 'd-none' : '')}>
               
                <ul className="mb-1">
                  <li className="w-100" onClick={() => googleLogin()}>
                    <img src={Icons[0].gmailImg} className="" alt="" />
                        {GShowLoader ? (<>
                          Sign up with Google <div className="spinner-border " role="status">  </div> 
                        
                        </>):(<>
                          Sign up with Google
                        </>)} 
                  
                  </li> 
                </ul>
                <p className="optionSignin "><span>or</span></p>
              </span>

                <form onSubmit={handleSubmit} autoComplete="off">
               
                  <div className='inputGroupDiv'> 
                      <div className={"inputTxtBox registerInputDiv " + (isGmail ? 'disabled' : '')}>
                        <img src={Icons[0].userImg} className="logoImg" alt="" />
                          <input type="text" value={fullName} placeholder="Full Name" maxLength="100" onChange={handleFullNameChange} readOnly={isGmail} />  
                      
                      </div>
                      {errors.fullName && <span  className="errorTxt" >{errors.fullName}</span>}
                </div>
                  <div className='inputGroupDiv'> 
                      <div className={"inputTxtBox registerInputDiv " + (isGmail ? 'disabled' : '')}>
                        <img src={Icons[0].mailImg} className="logoImg" alt="" />
                          <input type="email" value={email} placeholder="Email id" autoComplete="email" onChange={handleEmailChange} readOnly={isGmail}/>  
                      
                      </div>
                      {errors.email && <span  className="errorTxt" >{errors.email}</span>}
                </div>
                  <div className="mb-4">
                    <PhoneInput 
                      autocomplete="off" 
                       defaultCountry="US"
                       country={"us"}
                      id="phone"
                      placeholder="Enter phone number"
                      value={phoneNumber}
                      onChange={setPhoneNumber} 
                      international={false}
                      error={!isValid && phoneNumber.trim().length > 0}
                      onBlur={() => setIsValid(!!phoneNumber.trim())}
                      inputProps={{
                        name: 'phone',
                        required: true,
                        autoFocus: true, 
                        autoComplete: 'off',
                      }}  
                    />
                    {errors.phoneNumber && <span  className="errorTxt" >{errors.phoneNumber}</span>}
                  </div>                  
                  
                  <div className={'inputGroupDiv ' + (isGmail ? 'd-none' : '')}> 
                      <div className="inputTxtBox registerInputDiv">
                            <img src={Icons[0].lockedImg} className="logoImg" alt="" />
                              <input type={passwordType}  value={password} placeholder="Password" autoComplete="new-password" onChange={handlePasswordChange}/>   
                              <label className='eyePwdIcon' onClick={handleClickPassword}>  
                                <img src={passwordType === "password" ? ( Icons[0].closeEye  ) : ( Icons[0].opneEye  )} className="logoImg" alt="" />
                              </label>                
                          </div>
                          {errors.password && <span  className="errorTxt" >{errors.password}</span>}
                    </div>
                  
                  <div className="optDivBox mt-4">
                  <div className="switch-container d-flex">
                        <label>
                          <input
                            type="checkbox"
                            checked={isChecked}
                            onChange={handleChange}
                            className="switch"
                          />
                          <div className="switch-slider">
                            <div className="switch-knob"></div>
                          </div>
                        </label>

                        <span style={{ marginLeft: "5px" }} > 
                          {/* I agree to the  */}
                          By signing up, you agree to our
                          <b style={{cursor:"pointer", color: '#0d6efd' }} onClick={() => openModal()}> Terms of Use & Privacy Policy.</b>
                          {/* By signing up, you agree to our 
                          <b className="d-none"
                          style={{ cursor: selectedToggle ? "pointer" : "default", color: "#0d6efd" }}
                          onClick={selectedToggle ? () => openModal() : null}
                          // style={{cursor:"pointer", color: '#0d6efd' }} onClick={() => openModal()}
                            > {" "}
                            Terms and Privacy Policy</b>  */}
                          {/* Terms and Privacy Policy */}
                          </span>
                      </div>

                    {/* <span className="switchToogle "><input type="checkbox" id="switch"   onChange={handleOptionChangeToogle} /><label for="switch" >Toggle</label>
                     I agree to the Terms of Use & Privacy Policy.</span>  */}
                    
                  </div>
                  {ShowLoader ? (<>
                      <button  className="signInBtn" > Loading
                      <div className="spinner-border text-light  " role="status">
                       <span className="visually-hidden">Loading...</span>
                    </div> 
                    </button>
                    </>):(<>
                      <button className="signInBtn " type="submit" disabled={selectedToggle}>Continue</button>
                    </>)}
                 
                 <div className="signupDiv">
                  Already have an account <Link to="/">Sign in</Link>
                  </div>
                </form>
             </div>

             <div className={"singUpThreeStep "+(twoStep ? "":"d-none")}>
                    {/* <h3 className="titleDespTxt">OTP Verification</h3>  
                    <p>Enter the OTP sent to +1 234 267 9900</p>
                    
                    <p>Didn't you receive the OTP? <button>Resend OTP</button></p>
                    {ShowLoader ? (<>
                      <button  className="signInBtn" > Loading
                      <div className="spinner-border text-light  " role="status">
                       <span className="visually-hidden">Loading...</span>
                    </div> 
                    </button>
                    </>):(<>
                      <button className="signInBtn " type="submit" disabled={selectedToggle}>OK</button>
                    </>)} */}
                     <div  className="VerificationOTPMain">
                     
                     <img src={Icons[0].OTPIcon} className="" alt="" />
                        <h3 className="titleDespTxt">OTP Verification</h3>
                        <p>Enter the OTP sent to +{phoneNumber}</p>
                          <form onSubmit={handleSubmitOTP}>
                              <div onPaste={handlePaste}>
                                {otp.map((data, index) => (
                                  <input
                                    key={index}
                                    type="text"
                                    maxLength="1"
                                    value={data}
                                    className="inputOTP"
                                    ref={(el) => (inputRefs.current[index] = el)}
                                    onChange={(e) => handleOTPChange(e.target, index)}
                                    onKeyDown={(e) => handleBackspace(e, index)}
                                    onFocus={(e) => e.target.select()} 
                                    style={{ 
                                      borderBottom: `2px solid ${data ? '#2743FD' : 'gray'}`, // Dynamic border color 
                                      transition: 'border-color 0.2s', // Smooth transition
                                    }}
                                  />
                                ))}
                              </div>
                          <div  className=" ResendOTPBtn" 
                                style={{ 
                                      color: `${resendAvailable ? '#333' : '#B9B9B9'}`,  
                                      marginTop: '10px' 
                                    }}>
                           Didn't you receive the OTP?  <button onClick={handleResend} disabled={!resendAvailable}>
                            Resend OTP
                          </button> 
                          <p className="countdownTxt">{!resendAvailable && `${timer} seconds`}</p>
                        </div> 

                          {ShowLoader ? (<>
                            <button  className="signInBtn" style={{ marginTop: '20px' }}> Loading
                            <div className="spinner-border text-light  " role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div> 
                          </button>
                          </>):(<>
                            <button className="signInBtn style={{ marginTop: '20px' }}" type="submit" disabled={!isOtpComplete}>OK</button>
                          </>)} 
                    
                        </form>
                      
                      </div>
              </div>
           

              <div className={"singUpThreeStep "+(threeStep ? "":"d-none")}>
              <h3 className="titleDespTxt">Please fill details to continue</h3>
                <form  onSubmit={handleSubmitPart2} autoComplete="off">
                  <div className={"inputTxtBox registerInputDiv "+ (fullName.length > 0 ? 'disabled' : '')}>
                    <img src={Icons[0].userImg} className="logoImg" alt="" />
                    <input type="text" value={fullName} placeholder="Full Name"  readOnly />
                  </div>
                  <div className={"inputTxtBox registerInputDiv "+ (email.length > 0 ? 'disabled' : '')}>
                    <img src={Icons[0].mailImg} className="logoImg" alt="" />
                    <input type="text" value={email} placeholder="Email id" readOnly  /> 
                  </div>
                  <div className={"registerInputDiv "+ (email.length > 0 ? 'disabled' : '')}>
                    <PhoneInput
                      defaultCountry="US"
                      country={"us"}
                     id="phone"
                     placeholder="Enter phone number"
                     value={phoneNumber}
                     onChange={setPhoneNumber} 
                     international={false}
                     error={!isValid && phoneNumber.trim().length > 0}
                     onBlur={() => setIsValid(!!phoneNumber.trim())}
                     inputProps={{
                       name: 'phone',
                       required: true,
                       autoFocus: true
                     }} 
                    />
                  </div> 
                      <div className="inputTxtBox  registerInputDiv">
                        <img src={Icons[0].dateIcon} className="logoImg" alt="" />
                        <input type="text"  maxLength="11"  value={formatDate(DOBTxt)} placeholder="Date of Birth (YYYY-MM-DD)"  
                         
                            /> 
                          <button className="toggleCalendarBtn"  onClick={toggleCalendar}> <img src={Icons[0].calendarIcon} className="logoImg" alt="" /></button>
                          {showCalendar && (
                              <Calendar 
                                className= 'inputCaledar' 
                                onChange={onChangeCalendar}
                                value={DOBTxt}
                                maxDate={new Date()} 
                                tileDisabled={disablePastDates} 
                              />
                          )}
     </div>
                  {errors.DOBTxt && <span  className="errorTxt" >{errors.DOBTxt}</span>} 
                  
                      <div className="inputTxtBox  registerInputDiv d-flex">
                        <img src={Icons[0].GenderImg} className="logoImg" alt="" />
                        <div className="gender-selector">
                            <label>
                              <input
                                type="radio"
                                value="Male"
                                checked={GenderTxt === 'Male'}
                                onChange={handleGenderChange}
                              />
                              Male
                            </label>
                            <label>
                              <input
                                type="radio"
                                value="Female"
                                checked={GenderTxt === 'Female'}
                                onChange={handleGenderChange}
                              />
                              Female
                            </label>
                            <label>
                              <input
                                type="radio"
                                value="Other"
                                checked={GenderTxt === 'Other'}
                                onChange={handleGenderChange}
                              />
                              Other
                            </label>
                          </div>
                           {/* <input type="text" value={GenderTxt} placeholder="Press M or F for gender" onChange={handleGenderChange} maxLength="1"   
                        onKeyUp={(e) => { if (e.key === 'Backspace') {     setGenderTxt('');  } }}/>  */}
                  </div>
                  {errors.GenderTxt && <span  className="errorTxt" >{errors.GenderTxt}</span>} 
                  <div className="inputTxtBox registerInputDiv ">
                    <img src={Icons[0].InsuranceIDIcon} className="logoImg" alt="" />
                
                   <input type="text"
                    value={InsuranceIdTxt}  
                    // onChange={(e) => setInsuranceIdTxt(e.target.value)}  
                    placeholder="Insurance ID"
                    maxLength="40"
                    onKeyDown={InsuranceIdHandleKeyDown}
                    onChange={InsuranceIdHandleChange}
                     />
                  </div>
                  {errors.InsuranceIdTxt && <span  className="errorTxt" >{errors.InsuranceIdTxt}</span>} 
                   
                  {ShowLoader ? (<>
                      <button  className="signInBtn" > Loading
                      <div className="spinner-border text-light  " role="status">
                       <span className="visually-hidden">Loading...</span>
                    </div> 
                    </button>
                    </>):(<>
                      <button className="signInBtn registerBtn mb-0"   >Finish</button>
                    </>)}
              </form>
              </div>
              <div className={"singUpFinalStep  "+(finalStep ? "":"d-none")}>
                    <span className="emailVerificationDiv">
                    <img src={Icons[0].checkedIcon} className="logoImg" alt="" />
                    <h3>Success!</h3>
                    <p>Congratulations! Your account has been created successfully. Continue to the dashboard.</p>
                    <button className="signInBtn mb-0"   onClick={routeChange} >Continue</button>
               
                    </span>
              </div>
            </div>

           
          </div>
          
        </div>
      
      </div>

        {/* Modal Popup for Terms of Use & Privacy Policy */}
        <Modal
       className='consentCheckModal modalViewAllMain'
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Document Viewer"
       
      >
       
        <div className="innerModalDiv overflow-hidden"> 
        <ConsentNotice  onAgree={handleAgree} onDecline={handleDecline} />
        {/* Ensure selectedDocument exists before rendering */}
        </div>
      </Modal>

    </div>
  );
}

export default SingupScreen;